export default __webpack_public_path__ + "static/media/lockup-safari.a5b81e28.mov";